module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/chiba-funabashi-point2-3-6ebcfb189cbcc1ecd52eaa6780df7b9e.webp";